export default __webpack_public_path__ + "static/media/za.19b066d9.jpg";